import React from 'react';
import { getItemWebUrl, prepEntityTypeLower } from '/src/lib/helpers';



export const getCompanyUrl = (company) => {
    let companyUrl = '';
    companyUrl = getItemWebUrl(prepEntityTypeLower(company.type), company.id, company.code);
    return companyUrl;
}

export const getCompanyImg = (company, showTestData) => {
    // handle test data without company name
    if (company.name) {
        let companyImage = company.logo;
        if (showTestData) {
            companyImage = <div className='startupLogo'></div>;
        } else {
            if (companyImage) {
                companyImage = <div className='startupLogo' style={{ backgroundImage: `url('${companyImage}')` }}></div>;
            } else {
                companyImage = <div className='startupLogo'><h2>{company.name.substr(0, 1).toUpperCase()}</h2></div>;
            }
        }
        return companyImage;
    } else {
        return <div className='startupLogo'><h2>?</h2></div>;
    }
}

export const getInvestorURL = (inv) => {
    let investorUrl = '';
    const type = inv && (inv.type || inv.entity_type);
    if (!type) return investorUrl;
    if (type.toLowerCase() === 'user') {
        investorUrl = undefined;
    } else {
        investorUrl = getItemWebUrl(prepEntityTypeLower(type), inv.id, inv.code);
    }
    return investorUrl;
}

export const getInvestorLogo = (inv, className = '') => {
    // handle test data without investor name
    if (inv && inv.name) {
        let invImage = inv && inv.logo;
        if (invImage) {
            invImage = <div className={`startupLogo ${className}`} style={{ backgroundImage: `url('${invImage}')` }}></div>
        } else {
            invImage = <div className={`startupLogo ${className}`}><h2>{inv && inv.name.substr(0, 1).toUpperCase()}</h2></div>
        }
        return invImage;
    } else {
        return <div className={`startupLogo ${className}`}><h2>?</h2></div>
    }
}

export const getUserProfilePic = (user = {}) => {
    // handle test data without investor name
    if (user.first_name) {
        let userImage = user.profile_pic;
        if (userImage) {
            userImage = <div className='startupLogo' style={{ backgroundImage: `url('${userImage}')` }}></div>
        } else {
            userImage = <div className='startupLogo'><h2>{user.first_name.substr(0, 1).toUpperCase()}</h2></div>
        }
        return userImage;
    } else {
        return <div className='startupLogo'><h2>?</h2></div>
    }
}
